import { render } from "./PpolicyComp.vue?vue&type=template&id=7f142848&scoped=true"
import script from "./PpolicyComp.vue?vue&type=script&lang=js"
export * from "./PpolicyComp.vue?vue&type=script&lang=js"

import "./PpolicyComp.vue?vue&type=style&index=0&id=7f142848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f142848"]])

export default __exports__